import { Toaster } from './Toaster'
export default Toaster

export { Toaster, emit} from './Toaster'
